/**
 * Environment detection utility for production readiness
 */

export const isDevelopment = () => {
  // If we're on localhost, it's definitely development
  if (window.location.hostname === 'localhost') {
    console.log('Environment: Development (localhost detected)');
    return true;
  }
  // For any other domain, treat as production regardless of build type
  console.log('Environment: Production (non-localhost domain)');
  return false;
};

export const isProduction = () => {
  return !isDevelopment();
};

export const shouldShowDebugFeatures = () => {
  return isDevelopment();
};

export const shouldShowSampleData = () => {
  // Only show sample data in development or if explicitly enabled
  return isDevelopment() || localStorage.getItem('enable_sample_data') === 'true';
};

export const getEnvironmentName = (): 'development' | 'staging' | 'production' => {
  if (window.location.hostname === 'localhost') {
    return 'development';
  }
  if (window.location.hostname.includes('staging') || window.location.hostname.includes('test')) {
    return 'staging';
  }
  return 'production';
};

export const config = {
  // Domain configuration
  DOMAIN: 'rentflow.space',
  BASE_URL: 'https://rentflow.space',
  
  // Environment detection
  isDevelopment: () => getEnvironmentName() === 'development',
  isProduction: () => getEnvironmentName() === 'production',
  isStaging: () => getEnvironmentName() === 'staging'
};
